<template>
    <div class="d-flex align-center" v-bind="$attrs">
        <v-icon v-if="!hideCounter" class="appbar-icon-button-small btn-bg-color-blue dark-blue-color mr-2" data-cy="datatable-quantity-minus" style="cursor: pointer" small @click="$emit('decrement')">mdi-minus</v-icon>
        <div v-else class="ml-5 mr-4" style="padding-right: 2px"></div>

        <v-text-field
            v-if="!hideInput"
            data-cy="datatable-quantity-value"
            class="quantity-counter-input"
            :class="inputClass"
            oninput="if(Number(this.max) != 0 && Number(this.value) > Number(this.max)) this.value = this.max;"
            @beforeinput="validateQuantityInput"
            :value="value"
            :min="min"
            :max="max"
            @input="$emit('input', parseQuantity($event))"
            outlined
            hide-details
            :dense="dense"
            type="number"
            :readonly="readonly"
            :disabled="disabled"
        ></v-text-field>

        <v-icon v-if="!hideCounter" class="appbar-icon-button-small btn-bg-color-blue dark-blue-color ml-2" data-cy="datatable-quantity-plus" style="cursor: pointer" small @click="$emit('increment')">mdi-plus</v-icon>
        <div v-else class="ml-5 mr-4" style="padding-left: 2px"></div>
    </div>
</template>

<script>
export default {
    props: {
        value: Number,
        min: {
            type: Number,
            default: 0,
        },
        max: {
            type: Number,
            default: 99999, // @Note: Keep the validateQuantityInput Regex with 1 more digit than this value to allow the "oninput" on the v-text-field to do its magic
        },

        hideCounter: {
            type: Boolean,
            default: false,
        },

        hideInput: {
            type: Boolean,
            default: false,
        },

        dense: {
            type: Boolean,
            default: false,
        },

        readonly: {
            type: Boolean,
            default: false,
        },

        disabled: {
            type: Boolean,
            default: false,
        },

        isActiveCampaign: {
            type: Boolean,
            default: false,
        },

        inputClass: {
            type: String,
            default: '',
        },
    },

    data() {
        return {
            inputAllSelected: false,
        };
    },

    computed: {
        regexExpression() {
            // Regex: Only allow 1 to the max length of numbers between 0 and 9 - read the note on the "max" prop to understand the (max length + 1)
            const maxLength = this.max.toString().length + 1;
            return new RegExp('^([0-9]{1,' + maxLength.toString() + '}?)$');
        },
    },

    methods: {
        validateQuantityInput(event) {
            event = event ? event : window.event;

            const oldInput = event.target.value.toString();
            const newInput = event.data?.toString();
            const finalValue = oldInput + newInput;

            if (this.isActiveCampaign) this.handleCampaignInput(event, oldInput, newInput);

            if (newInput !== undefined && this.parseQuantity(finalValue) < this.min) {
                event.preventDefault();
            }

            // undefined in this case means the user inputted a backspace.
            if (newInput !== undefined && this.max !== 0 && !this.regexExpression.test(finalValue)) {
                event.preventDefault();
            }
        },

        handleCampaignInput(event, oldInput, newInput) {
            this.getInputSelectedValue();

            // In this case, user has inputted a 0 value in an active campaign product
            if (this.inputAllSelected && newInput == 0) {
                event.preventDefault();
                this.$emit('input-remove-campaign');
            }

            // In this case, user has inputted a backspace in an active campaign product and we want to show the remove campaign confirmation dialog,
            // keeping the last known quantity (used if the user closes the dialog without confirm).
            if (newInput === undefined && oldInput.length == 1) {
                event.preventDefault();
                this.$emit('input-remove-campaign');
            }
        },

        getInputSelectedValue() {
            const selection = window.getSelection();
            this.inputAllSelected = selection.toString() === this.value.toString();
        },
    },
};
</script>
